module.exports = __webpack_public_path__ + "static/media/p1.cc3e9f89.jpeg";